module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CheckoutHeader":{"heading":"Potřebujete poradit?"}}}')
  delete Component.options._Ctor
}
